__turbopack_context__.v({
  "buttons": "NotFound-module-scss-module__BLS5xW__buttons",
  "heading": "NotFound-module-scss-module__BLS5xW__heading",
  "main": "NotFound-module-scss-module__BLS5xW__main",
});
